import { useQuery } from 'react-query';
import { AadeBookInvoiceType } from '../../../interfaces/myData.interface';
import { DeliveryNoteStatus } from '../../../interfaces/myDataDelivery.interface';
import { GenericResponse } from '../../../interfaces/shared.interface';
import { apiRQ } from '../../api';

export interface DocDataByMark extends GenericResponse {
  data?: DeliveryNoteStatus;
  extraData?: {
    doc?: AadeBookInvoiceType;
    /**
     * Whether the current company is the doc's issuer, vs. its counterpart (recipient). Only known
     * when the doc could be fetched (issuer/recipient only) -- undefined for anyone else (e.g. a
     * carrier). GetDeliveryNoteStatus now succeeds for the recipient too (see `issuerVatNumber` in
     * billease-server), so this must come from the server explicitly rather than being inferred
     * from whether `data` is populated.
     */
    isIssuer?: boolean;
  };
}

const getDeliveryStatusByMarkService = async (mark: string | undefined): Promise<DocDataByMark> => {
  const resp = await apiRQ.get<DocDataByMark>(`/delivery/mark/${mark}`);

  return resp?.data;
};

export const useDeliveryStatusByMark = (mark: string | undefined) => {
  return useQuery<DocDataByMark, Error>(['useDeliveryStatusByMark', mark], () => getDeliveryStatusByMarkService(mark), {
    enabled: !!mark && mark !== 'create',
    cacheTime: 2000,
    staleTime: 2000,
    refetchOnWindowFocus: false,
    refetchOnMount: false,
  });
};
